<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="grid-view matic-reconciliation">
    <div class="main-content">
      <div class="section operations triggers">
        <div>
          <el-button type="primary" size="mini" @click="detailCancel">{{ $t('Clearing.ReturnToReconciliationNewVersion') }}</el-button>
          <el-button v-show="!isShow && redisKey" type="primary" size="mini" @click="reconciliation">{{ $t('Clearing.StartReconciliation') }}</el-button>
          <el-button v-show="isShow" :disabled="!throttle" type="primary" size="mini" @click="detailSave">{{ $t('Clearing.Save') }}</el-button>
          <el-button v-show="isShow" type="primary" size="mini" @click="manualReconciliationFunc(false)">{{ $t('Clearing.ManualReconciliation') }}</el-button>
          <el-button v-show="isShow" type="primary" size="mini" @click="cancelAll">{{ $t('Clearing.CancelManualReconciliation') }}</el-button>
        </div>
        <div class="footer-check">
          <el-checkbox-group v-model="checkList" @change="statusChanges">
            <el-checkbox label="0">{{ $t('Clearing.ShowAllReconciliationFees') }}</el-checkbox>
            <el-checkbox label="1">{{ $t('Clearing.ShowFullyReconciledFees') }}</el-checkbox>
            <el-checkbox label="2">{{ $t('Clearing.ShowPartiallyReconciledFees') }}</el-checkbox>
            <el-checkbox label="3">{{ $t('Clearing.ShowUnmatchedFees') }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <p class="instructions section">
        {{ $t('Clearing.Note') }}
        <span style="color:green;">{{ $t('Clearing.Green') }}</span>{{ $t('Clearing.IndicatesReconciliationResultIsConsistent') }}
        <span style="color:#000;">{{ $t('Clearing.Black') }}</span>{{ $t('Clearing.IndicatesCorrespondingFeeNotFound') }}
        <span style="color:red;">{{ $t('Clearing.Red') }}</span>{{ $t('Clearing.IndicatesAmountInconsistency') }}
        <span style="color:orange;">{{ $t('Clearing.Orange') }}</span>{{ $t('Clearing.IndicatesManualReconciliationCompleted') }}
        <el-checkbox v-model="sendEmail" style="margin-left: 15px;">{{ $t('CargoMsg.Cargo_SendEmailByReconciliationDiff') }}</el-checkbox>
      </p>
      <p class="instructions section" style="color:red;">{{ $t('Clearing.IfEtcPleaseGoModule') }}</p>
      <div class="details-list grid-wrapper">
        <div class="details-content grid-wrapper">
          <div class="left">
            <p>{{ $t('Clearing.ImportExternalFees') }}</p>
            <cargo-ag-grid
              config-module="20220610"
              :grid-options="externalGridOptions"
              :column-defs="externalColumnDefs"
              :row-data="externalData"
            />
            <!-- 分页 -->
            <div class="uniform">
              <div>
                <cargo-pagination
                  config-module="41001220012"
                  :total="externalPaging.total"
                  :page.sync="externalPaging.pageNum"
                  :limit.sync="externalPaging.pageSize"
                  @pagination="getList()"
                />
              </div>
              <div v-show="externalPaging.total !== 0 && redisKey" class="combined">
                <p v-for="(item, index) in externalAmountList" :key="index" class="usd">
                  {{ $t('Message.AllPage1') }}{{ item.total }}{{ $t('Message.Transactions') }}，
                  <span style="font-weight: bold;">{{ item.currency }}：</span>
                  <span style="font-style: oblique;">{{ item.amount.toFixed(2) }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="right">
            <p>{{ $t('Clearing.SystemInternalFees') }}</p>
            <cargo-ag-grid
              config-module="20220611"
              :grid-options="internalGridOptions"
              :column-defs="internalColumnDefs"
              :row-data="internalData"
            />
            <!-- 分页 -->
            <div class="uniform">
              <div>
                <cargo-pagination
                  config-module="41001220013"
                  :total="internalPaging.total"
                  :page.sync="internalPaging.pageNum"
                  :limit.sync="internalPaging.pageSize"
                  @pagination="getList()"
                />
              </div>
              <div v-show="internalPaging.total !== 0 && redisKey" class="combined">
                <p v-for="(item, index) in internalAmountList" :key="index" class="usd">
                  {{ $t('Message.AllPage1') }}{{ item.total }}{{ $t('Message.Transactions') }}，
                  <span style="font-weight: bold;">{{ item.currency }}：</span>
                  <span style="font-style: oblique;">{{ item.amount.toFixed(2) }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 对账规则选择 -->
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="rulesDialog"
      :title="$t('Clearing.SelectReconciliationRules')"
      width="500px"
      :show-close="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <div style="margin:0 auto;width: 100%;">
          <cargo-ag-grid
            :grid-options="rulesGridOptions"
            :column-defs="rulesColumnDefs"
            :row-data="rulesData"
            @gridReady="onCostGridReady"
          />
          <p style="margin:5px 0 0 0;">{{ $t('Clearing.IfMaintainReconciliationRulesClick') }}
            <span style="color:#4283ff;cursor:pointer;" @click="jump">{{ $t('Clearing.ReconciliationRuleEngineConfiguration') }}</span>
          </p>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="rulesDetermine">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button size="mini" @click="rulesCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import convertResToBlob from '@/utils/convertResToBlob'
import { getLoading } from '@/utils/utilBaseElement'
import { getGridSelected } from '@/utils/agGrid'
import {
  cancleManualReconciliation,
  exportReconciliation,
  queryReconciliationList,
  detailSaveReconciliation,
  checkAccount,
  manualReconciliation,
  exportReconciliationInternal
} from '@/api/clearing/tabAutomaticReconciliation'
import { queryRuleList } from '@/api/sysManage/ruleEngineSetup'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import { BuriedPointUtils } from '@/utils/BuriedPointUtils'
import { getUserInfo } from '@/utils/auth'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'TabAutomaticReconciliation',
  data() {
    return {
      matchCondition: '',
      throttle: true,
      checkedId: '0',
      loading: false,
      exportMark: '',
      checkList: ['0'],
      lastData: [],
      manualReconciliationList: {
        external: [],
        internal: []
      },
      externalPaging: {
        total: 0,
        pageNum: 1,
        pageSize: 100
      },
      internalPaging: {
        total: 0,
        pageNum: 1,
        pageSize: 100
      },
      externalAmountList: [], // 外部币种金额分类合计
      internalAmountList: [], // 内部币种金额分类合计
      externalGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: false,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        suppressContextMenu: false, // 右键列表弹出菜单
        // 勾选
        onSelectionChanged: (params) => {
          this.manualReconciliationRow()
        },
        // 点击行
        onRowDoubleClicked: (params) => {
          if (this.isShow) {
            this.highlight(params, 1)
          }
        },
        // 设置行样式
        getRowStyle: (params) => {
          return this.setRowColor(params)
        },
        getContextMenuItems: (params) => {
          const self = this
          return [
            'copy',
            {
              name: this.$t('Clearing.ManualReconciliation'),
              action: function() {
                self.manualReconciliationFunc()
              }
            },
            {
              name: this.$t('Clearing.CancelAllManualReconciliations'),
              action: function() {
                self.cancelAll()
              }
            },
            {
              name: this.$t('Clearing.ExportAllComparisonResults'),
              id: 0,
              action: function() {
                self.exportReconciliationFunc(this.id)
              }
            },
            {
              name: this.$t('Clearing.ExportConsistentComparisonResults'),
              id: 1,
              action: function() {
                self.exportReconciliationFunc(this.id)
              }
            },
            {
              name: this.$t('Clearing.ExportDiscrepancyComparisonResults'),
              id: 2,
              action: function() {
                self.exportReconciliationFunc(this.id)
              }
            }
          ]
        }
      },
      rulesDialog: false,
      externalColumnDefs: [],
      externalData: [],
      init: [],
      internalGridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: false,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        suppressContextMenu: false, // 右键列表弹出菜单
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        },
        onSelectionChanged: () => {
          this.manualReconciliationRow()
        },
        onRowDoubleClicked: (params) => {
          if (this.isShow) {
            this.highlight(params, 2)
          }
        },
        getRowStyle: (params) => {
          return this.setRowColor(params)
        },
        getContextMenuItems: () => {
          const self = this
          return [
            'copy',
            {
              name: this.$t('Clearing.ManualReconciliation'),
              action: function() {
                self.manualReconciliationFunc()
              }
            },
            {
              name: this.$t('Clearing.CancelAllManualReconciliations'),
              action: function() {
                self.cancelAll()
              }
            },
            {
              name: this.$t('Clearing.ExportAllComparisonResults'),
              id: 0,
              action: function() {
                self.exportReconciliationFuncInternal(this.id)
              }
            },
            {
              name: this.$t('Clearing.ExportConsistentComparisonResults'),
              id: 1,
              action: function() {
                self.exportReconciliationFuncInternal(this.id)
              }
            },
            {
              name: this.$t('Clearing.ExportDiscrepancyComparisonResults'),
              id: 2,
              action: function() {
                self.exportReconciliationFuncInternal(this.id)
              }
            }
          ]
        }
      },

      internalColumnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: (params) => {
            return (params.data.color === 2 || params.data.color === 0) && this.isShow
          },
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('Clearing.BusinessNumber'),
          field: 'jobNo',
          width: 100,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: 'MBL.NO',
          field: 'mbl',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: 'SO NO',
          field: 'sono',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.ShipName'),
          field: 'vessel',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.Voyage'),
          field: 'voyageFlight',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.ContainerNumber'),
          field: 'containerno',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.ConfirmationStatus'),
          field: 'end',
          width: 150,
          cellRenderer: (params) => {
            return this.internalConfirmStatus(params)
          },
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.CostName'),
          field: 'chargeItemName',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.Currency'),
          field: 'currency',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.TaxIncludedPrice'),
          field: 'amount',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          },
          cellRenderer: (params) => {
            return (params.data.amount).toFixed(2)
          }
        },
        {
          headerName: this.$t('Clearing.PriceExclusiveOfTax'),
          field: 'excludingTaxAmount',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          },
          cellRenderer: (params) => {
            return params.value.toFixed(2)
          }
        },
        {
          headerName: this.$t('Clearing.TaxRate'),
          field: 'taxRate',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          },
          cellRenderer: (params) => {
            return params.value.toFixed(2)
          }
        },
        {
          headerName: this.$t('Clearing.TaxAmount'),
          field: 'taxAmount',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          },
          cellRenderer: (params) => {
            return params.value.toFixed(2)
          }
        },
        {
          headerName: this.$t('Clearing.Difference'),
          field: 'diffAmount',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          },
          cellRenderer: (params) => {
            return (params.data.diffAmount).toFixed(2)
          }
        },
        {
          headerName: this.$t('Clearing.ReconciliationAmount'),
          field: 'billingAmount',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          },
          editable: (params) => {
            return this.editor(params)
          },
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true },
          onCellValueChanged: (params) => {
            params.data.diffAmount = params.data.amount - params.newValue
            params.api.refreshCells({ columns: ['diffAmount', 'billingAmount'] })
          },
          cellRenderer: (params) => {
            return (Number(params.data.billingAmount)).toFixed(2)
          }
        },
        {
          headerName: this.$t('Clearing.UnitPrice'),
          field: 'chargeUnitRate',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          },
          cellRenderer: (params) => {
            return (params.data.chargeUnitRate).toFixed(3)
          }
        },
        {
          headerName: this.$t('Clearing.Quantity'),
          field: 'chargeQuantity',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          }
        },
        {
          headerName: this.$t('Clearing.InvoiceNumber'),
          field: 'invoiceNo',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WarehouseNo'),
          field: 'warehouseNo',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          }
        },
        {
          headerName: this.$t('SeaExport.HblNo'),
          field: 'hblNbr2',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          }
        },
        {
          headerName: this.$t('SeaExport.BusinessReferenceNo'),
          field: 'customerRefNo',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.ReconciliationResult'),
          field: 'reconciliationResult',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.Operation'),
          field: 'opName',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReconciliationStatus'),
          field: 'reconciliationState',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.reconciliationStateLabelFunc(params.value)
          },
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReconciliationDiffReason'),
          field: 'reconciliationDiffReason',
          width: 160,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChargeCreadBy'),
          field: 'createdBy',
          width: 120,
          cellRenderer: (params) => {
            const username = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            return username === '' ? this.$t('Clearing.System') : username
          },
          cellStyle: (params) => {
            return this.setColor(params)
          }
        }
      ],
      internalData: [],
      rulesGridOptions: {
        rowSelection: 'multiple',
        gridApi: null,
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        },
        onRowDragEnd: this.refreshSerialNumberForCost
      },
      rulesColumnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          rowDrag: true,
          sortable: true,
          suppressMenu: true,
          rowDragEntireRow: true,
          suppressSizeToFit: true,
          // resizable: false,
          headerCheckboxSelection: true,
          lockVisible: true,
          initialHide: false
        },
        {
          headerName: this.$t('Clearing.ReconciliationRuleName'),
          field: 'ruleName',
          width: 150
        },
        {
          headerName: this.$t('Clearing.ComparisonOrder'),
          field: 'sorting',
          width: 150
        }
      ],
      rulesData: [],
      isShow: false,
      redisKey: '',
      sendEmail: false // 保存时是否同步邮件通知费用创建人员对账金额不一致
    }
  },
  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler(val) {
        const results = (this.$route.params.redisKey !== this.redisKey) && this.$route.params.redisKey
        if (val.name === 'AutomaticReconciliation' && results) {
          this.redisKey = this.$route.params.redisKey
          this.externalColumnDefs = []
          this.getList(this.$route.params.successNum)
          BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_2')
        }
      }
    }
  },
  methods: {
    // 跳转对账规则引擎配置
    jump() {
      this.rulesCancel()
      this.$router.push({
        name: 'RuleEngineSetup'
      })
    },
    onCostGridReady(params) {
      this.rulesGridOptions.gridApi = params.api
    },
    // 规则列可以拖动并且对比顺序根据拖动改变
    refreshSerialNumberForCost(e) {
      if (this.rulesGridOptions.gridApi) {
        this.rulesGridOptions.gridApi.forEachNode(node => {
          const charge = node.data
          charge.sorting = node.rowIndex + 1
        })
        this.rulesGridOptions.gridApi.refreshCells({ force: true }) // 刷新
      }
    },
    // 设置行背景色
    setRowColor(params) {
      if (params.node.data.lightMatch === 1) {
        return { background: '#6abdff !important' }
      } else {
        if (params.node.data.id % 2 !== 1) {
          return { background: '#FFFFFF !important' }
        } else {
          return { background: '#F7F7F7 !important' }
        }
      }
    },
    // 单击高亮
    highlight(params, id) {
      // 清空上次内部高亮行
      this.internalGridOptions.api.forEachLeafNode((node) => {
        node.setSelected(false)
      })
      // 清空上次外部高亮行
      this.externalGridOptions.api.forEachLeafNode((node) => {
        node.setSelected(false)
      })
      // 再次点击时，判断本次点击和上次点击是否为同一行，是同一行，则不传高亮参数
      if (this.matchCondition !== params.data.matchCondition) {
        this.getList(params, id)
        this.matchCondition = params.data.matchCondition
      } else {
        this.getList()
      }
    },
    // 根据勾选状态判断是否可编辑
    editor(params) {
      const internal = this.internalGridOptions.api.getSelectedRows()
      return internal.some((item) => {
        return item.id === params.data.id
      })
    },
    // 对账数据选中
    manualReconciliationRow() {
      const external = this.externalGridOptions.api.getSelectedRows()
      const internal = this.internalGridOptions.api.getSelectedRows()
      this.manualReconciliationList.external = external
      this.manualReconciliationList.internal = internal
      // 记录只有一条内部账单勾选数据时，当数据勾选从1变为0，拿到被取消勾选数据的id，
      if (internal.length === 1) {
        this.lastData = internal
      }
      // 当内部账单勾选数据为0时，则初始化最后一条数据的值，手动设置对账金额和差额为0
      if (internal.length === 0 && this.lastData.length !== 0) {
        const data = {
          ...this.lastData[0],
          billingAmount: 0,
          diffAmount: 0
        }
        //  根据记录的id拿到最后一次取消勾选的行，设置记录下的初始化数据
        const initialize = this.internalGridOptions.api.getRowNode(this.lastData[0].id)
        initialize.setData(data)
        this.lastData = []
      }

      // 外部勾选数为0，内部不为0时，或双边勾选多条，则手动填账，重置内部已勾选的对账金额为0
      if ((external.length === 0 && internal.length !== 0) || (external.length > 1 && internal.length > 1) || (external.length === 1 && internal.length > 1)) {
        internal.map((item) => {
          item.billingAmount = 0
          item.diffAmount = 0
        })
        // 设置所有列的对账金额为0
        this.internalGridOptions.api.updateRowData({ update: internal })
      }
      // 都只勾选一条时，直接把外部金额带到内部的队长金额中
      if (external.length === 1 && internal.length === 1) {
        internal[0].billingAmount = external[0].amount
        internal[0].diffAmount = internal[0].amount - internal[0].billingAmount
        this.internalGridOptions.api.updateRowData({ update: internal })
      }

      // 外部勾选多条且内部只有一条时，累加外部所有勾选的金额，平账到内部的对账金额
      if (external.length > 1 && internal.length === 1) {
        internal[0].billingAmount = external.reduce((pre, cur, index) => {
          if (index === 1) {
            return pre.amount + cur.amount
          } else {
            return pre + cur.amount
          }
        })
        internal[0].diffAmount = internal[0].amount - internal[0].billingAmount
        this.internalGridOptions.api.updateRowData({ update: internal })
      }
    },
    // 手工对账
    async manualReconciliationFunc() {
      BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_6')
      const external = this.manualReconciliationList.external
      const internal = this.manualReconciliationList.internal
      if (external.length === 0 || internal.length === 0) {
        this.$message.warning(this.$t('Clearing.PleaseNeedToBeReconciliation'))
        return
      }
      let { externalAamount, internalAamount } = ''
      if (external.length === 1) {
        externalAamount = external[0].amount
      } else {
        externalAamount = external.reduce((pre, cur, index) => {
          if (index === 1) {
            return Number(pre.amount) + Number(cur.amount)
          } else {
            return Number(pre) + Number(cur.amount)
          }
        })
      }
      if (internal.length === 1) {
        internalAamount = internal[0].billingAmount
      } else {
        internalAamount = internal.reduce((pre, cur, index) => {
          if (index === 1) {
            return Number(pre.billingAmount) + Number(cur.billingAmount)
          } else {
            return Number(pre) + Number(cur.billingAmount)
          }
        })
      }
      if (Number(externalAamount) !== Number(internalAamount)) {
        this.$message.warning(this.$t('Clearing.EnterReconciliationAmount'))
        return
      }
      const modifyArr = [...this.manualReconciliationList.external, ...this.manualReconciliationList.internal]
      const data = {
        redisKey: this.redisKey,
        selectedReconciliationChargeVoList: JSON.stringify(modifyArr)
      }
      const res = await manualReconciliation(data)
      if (res.ok) {
        this.$message.success(this.$t('Clearing.ManualReconciliationSucceeded'))
        // 手工对账成功后将选中的数据清空
        this.manualReconciliationList.external = []
        this.manualReconciliationList.internal = []
        // 将最后选中的一条数据清空，避免初始化下一条选中的数据
        this.lastData = []
        this.getList()
      }
    },
    // 取消手工对账
    cancelAll() {
      this.$confirm(this.$t('Clearing.AreCancelAllManualTime'), this.$t('Clearing.Prompt'), {
        confirmButtonText: this.$t('Clearing.Yes'),
        cancelButtonText: this.$t('Clearing.No'),
        type: 'warning'
      }).then(() => {
        BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_7')
        const params = {
          redisKey: this.redisKey
        }
        cancleManualReconciliation(params).then((res) => {
          if (res.ok) {
            this.$message.success(this.$t('Clearing.CancelAllManualReconciliationsSuccessful'))
            this.getList()
            this.lastData = []
          }
        })
      }).catch(() => {
      })
    },
    // 切换筛选
    statusChanges() {
      if (this.checkList.length > 1 && this.checkList.length !== 0) {
        this.checkList.splice(0, 1)
        if (this.redisKey) {
          this.internalPaging.pageNum = 1
          this.internalPaging.pageSize = 100
          this.externalPaging.pageNum = 1
          this.externalPaging.pageSize = 100
          this.getList()
        }
        this.checkedId = this.checkList[0]
      } else {
        this.checkList.push(this.checkedId)
      }
    },
    // 导出功能
    async exportReconciliationFunc(id) {
      switch (id) {
        case 0:
          BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_9')
          break
        case 1:
          BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_10')
          break
        case 2:
          BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_11')
          break
      }

      this.loading = getLoading()
      const data = {
        redisKey: this.redisKey,
        color: id
      }
      const res = await exportReconciliation(data).finally(() => {
        this.loading.close()
      })
      if (res) {
        convertResToBlob(res)
        this.$message.success(this.$t('Clearing.RequestSucceededExporting'))
        this.loading.close()
      }
    },
    // 导出内部功能
    async exportReconciliationFuncInternal(id) {
      switch (id) {
        case 0:
          BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_9')
          break
        case 1:
          BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_10')
          break
        case 2:
          BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_11')
          break
      }

      this.loading = getLoading()
      const fieldMappingList = []
      // 使用 map 函数遍历 internalColumnDefs 数组，并提取所需的参数
      this.internalColumnDefs.map(column => {
        if (column.headerName && column.field && column.field !== 'reconciliationResult') {
          const param = {
            excelColumnName: column.headerName,
            tableColumnName: column.field
          }
          fieldMappingList.push(param)
        }
      })
      const mappingParams = JSON.stringify(fieldMappingList)
      const data = {
        redisKey: this.redisKey,
        color: id,
        reconciliationTemplateMappingList: mappingParams
      }
      const res = await exportReconciliationInternal(data).finally(() => {
        this.loading.close()
      })
      if (res) {
        convertResToBlob(res)
        this.$message.success(this.$t('Clearing.RequestSucceededExporting'))
        this.loading.close()
      }
    },
    // 对账详情保存
    async detailSave() {
      if (!this.throttle) {
        return
      }
      this.loading = getLoading()
      this.throttle = false
      setTimeout(() => {
        this.throttle = true
      }, 3000)
      const data = {
        redisKey: this.redisKey, sendEmail: this.sendEmail
      }
      const res = await detailSaveReconciliation(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_5')
        this.getList()
        this.$message.success(this.$t('Clearing.SavedSuccessfully'))
      }
    },
    // 返回对账新版
    detailCancel() {
      this.isShow = false
      this.internalData = []
      this.externalData = []
      this.internalAmountList = []
      this.externalAmountList = []
      this.externalPaging.total = 0
      this.internalPaging.total = 0
      this.checkList = ['0']
      this.checkedId = '0'
      this.$route.params.redisKey = ''
      this.redisKey = ''
      this.$router.push({
        name: 'BillingNative',
        params: {
          refresh: true
        }
      })
      this.sendEmail = false
    },
    // 开始对账按钮
    async reconciliation() {
      BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_3')
      this.rulesData = []
      const data = {
        officeId: String(this.$store.getters.currentOfficeId)
      }
      this.$nextTick(() => {
        this.rulesDialog = true
        this.isShow = true
      })
      const res = await queryRuleList(data)
      if (res.data) {
        res.data.sort((s1, s2) => {
          const dates1 = new Date(s1.dateCreated).getTime()
          const dates2 = new Date(s2.dateCreated).getTime()
          return dates1 - dates2
        })
        res.data.map((item, index) => {
          item.sorting = index + 1
        })
        this.rulesData = res.data
      } else {
        this.rulesData = []
      }
    },
    // 开始对账-规则保存
    async rulesDetermine() {
      const rulesData = getGridSelected(this.rulesGridOptions)
      if (rulesData.length <= 0) {
        this.$message.warning(this.$t('Clearing.PleaseUseAndFillNumbers'))
      } else {
        rulesData.sort((a, b) => {
          return a.sorting - b.sorting
        })
        const ruleUuidList = []
        rulesData.map((item) => {
          ruleUuidList.push(...item.uuid.split(','))
        })
        const data = {
          redisKey: this.redisKey,
          ruleUuidList: JSON.stringify(ruleUuidList)
        }
        const res = await checkAccount(data)
        if (res.ok) {
          BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_4')
          this.lastData = []
          this.$message.success(`${this.$t('Clearing.ReconciliationConsistent')}${res.data.successNum}${this.$t('Clearing.Items')}，${this.$t('Clearing.InconsistentAmounts')}${res.data.amountDiffNum}${this.$t('Clearing.Items')}，${this.$t('Clearing.CorrespondingChargesNotFound')}${res.data.notFoundItemNum}${this.$t('Clearing.Items')}`)
          this.rulesDialog = false
          this.isShow = true
          this.getList()
        }
      }
    },
    // 对账规则-取消
    rulesCancel() {
      this.rulesDialog = false
      this.isShow = false
    },
    // 确定导入
    async determineScheme() {
      this.beforeUploadUsage()
    },
    // 转换内部表格确认状态为对应文本
    internalConfirmStatus(params) {
      if (params.value === 0) {
        return this.$t('Clearing.Unconfirmed')
      }
      if (params.value === 1) {
        return this.$t('Clearing.Confirmed')
      }
    },
    // 对账详情
    async getList(params, id) {
      this.loading = getLoading()
      const data = {
        color: this.checkList[0],
        redisKey: this.redisKey,
        inPageNum: this.internalPaging.pageNum,
        inPageSize: this.internalPaging.pageSize,
        outPageNum: this.externalPaging.pageNum,
        outPageSize: this.externalPaging.pageSize
      }
      if (typeof params === 'number') {
        this.externalData = []
        this.internalData = []
        this.internalPaging.total = 0
        this.externalPaging.total = 0
        data.firstRequestFlag = true
        // 第一次加载的时候，获取本地内存中的分页条数
        const currentUserInfo = getUserInfo()
        const inPageSizeCache = JSON.parse(localStorage.getItem(`local_pagination_page_size_cache_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${'41001220013'}`))
        const outPageSizeCache = JSON.parse(localStorage.getItem(`local_pagination_page_size_cache_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${'41001220012'}`))
        if (inPageSizeCache && inPageSizeCache > 0) {
          data.inPageSize = inPageSizeCache
        }
        if (outPageSizeCache && outPageSizeCache > 0) {
          data.outPageSize = outPageSizeCache
        }
      }
      if (typeof params === 'object') {
        data.matchCondition = params.data.matchCondition
        data.leftOrRightClicks = id
      } else {
        this.matchCondition = ''
      }
      const res = await queryReconciliationList(data).finally(() => {
        this.loading.close()
      })
      this.externalColumnDefs = [
        {
          headerName: '',
          initialWidth: 60,
          checkboxSelection: (params) => {
            return (params.data.color === 2 || params.data.color === 0) && this.isShow
          },
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }
      ]
      if (res.ok) {
        // 外部金额合计
        this.internalPaging.pageNum = res.data.inPageNum
        this.externalPaging.pageNum = res.data.outPageNum
        const externalCurrency = {}
        const externalAmountList = []
        res.data.outPageReconciliationChargeVoList?.forEach((item, index) => {
          item.id = index
          externalCurrency[item.currency] = externalCurrency[item.currency] || []
          externalCurrency[item.currency].push(item)
        })

        const externalCurrencyName = Object.keys(externalCurrency)
        externalCurrencyName.forEach(item => {
          let amount = 0
          let externalTotal = 0
          externalCurrency[item].forEach((item) => {
            externalTotal++
            amount += Number(item.amount)
          })
          externalAmountList.push({ 'currency': item, 'amount': amount, 'total': externalTotal })
          this.externalAmountList = externalAmountList
        })

        // 内部金额合计
        const internalCurrency = {}
        const internalAmountList = []
        // 对币种进行分类
        res.data.inPageReconciliationChargeVoList?.forEach((item, index) => {
          item.id = index
          internalCurrency[item.currency] = internalCurrency[item.currency] || []
          internalCurrency[item.currency].push(item)
        })

        const internalCurrencyName = Object.keys(internalCurrency)
        internalCurrencyName.forEach(item => {
          let amount = 0
          // 每个币种总共几笔费用
          let internalTotal = 0
          // 计算每个币种的金额
          internalCurrency[item].forEach(item => {
            internalTotal++
            amount += Number(item.amount)
          })
          internalAmountList.push({ 'currency': item, 'amount': amount, 'total': internalTotal })
          this.internalAmountList = internalAmountList
        })
        // if (id) {
        //   if (id === 1) {
        //     this.internalData = res.data.inPageReconciliationChargeVoList
        //   }
        //   if (id === 2) {
        //     this.externalData = res.data.outPageReconciliationChargeVoList
        //   }
        // } else {
        this.internalData = res.data.inPageReconciliationChargeVoList
        this.externalData = res.data.outPageReconciliationChargeVoList
        // }
        this.externalPaging.total = res.data.outTotal
        this.internalPaging.total = res.data.inTotal
        // 表头为接口返回，根据接口设置对应的接收字段
        res.data.reconciliationTemplateMappingList.map((item) => {
          switch (item.tableColumnName) {
            case 'MBL':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'mbl',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'VOYAGE_FLIGHT':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'voyageFlight',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'VESSEL':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'vessel',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'CHARGEITEMNAME':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'chargeItemName',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'AMOUNT':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'amount',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params, 'right')
                },
                'cellRenderer': (params) => {
                  return (params.data.amount).toFixed(2)
                }
              })
              break
            case 'CURRENCY':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'currency',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'CONTAINERNO':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'containerno',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'SONO':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'sono',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'CHARGE_UNIT_RATE':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'chargeUnitRate',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                },
                'cellRenderer': (params) => {
                  return (params.data.chargeUnitRate).toFixed(3)
                }
              })
              break
            case 'CHARGE_QUANTITY':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'chargeQuantity',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'INVOICENO':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'invoiceNo',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'JOBNO':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'jobNo',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'WAREHOUSE_NO':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'warehouseNo',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'HBL_NBR2':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'hblNbr2',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'CUSTOMER_REF_NO':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'customerRefNo',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'OP_NAME':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'opName',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
          }
        })
        this.externalColumnDefs.push({
          'headerName': this.$t('Clearing.ReconciliationResult'),
          'field': 'reconciliationResult',
          'width': 150,
          'cellStyle': (params) => {
            return this.setColor(params)
          }
        })
      }
      if (typeof params === 'number') {
        this.$message.success(`${this.$t('Clearing.ImportSucceeded')}：${params}${this.$t('Clearing.Items')}`)
        this.isShow = false
      }
    },
    // 设置颜色
    setColor(item, right) {
      switch (item.data.color) {
        case 0:
          return { color: '#000000', textAlign: right ? 'right' : '' }
        case 1:
          return { color: '#4B7902', textAlign: right ? 'right' : '' }
        case 2:
          return { color: '#D9001B', textAlign: right ? 'right' : '' }
        case 3:
          return { color: '#F59A23', textAlign: right ? 'right' : '' }
      }
    }
  }
}
</script>

<style lang="scss">
.matic-reconciliation{
  height: 100%;
  .instructions{
    margin:0;
    font-size: 14px;
    width: 100%;
    height: 30px;
    border-radius: 4px;
    border: 1px solid #f0f3f8;
    display: flex;
    align-items: center;
    flex-direction: row;
    padding-left: 10px;
    span{
      font-size: 14px;
    }
  }
  .footer-check{
    margin-top: 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .details-list{
    display: flex;
    flex-direction: column;
    .details-content{
      display: flex;
      .left,.right{
        width: 50%;
        border: 1px solid #cccccc;
        border-radius: 5px;
        background: #f0f3f8;
        padding: 0 10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
      }
      .uniform{
        display: flex;
        justify-content: space-between;
        .combined{
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: end;
          .usd{
            padding: 0 5px;
            box-sizing: border-box;
            text-align: right;
            margin: 0;
          }
        }
      }
    }
  }
}
#footer-wrapper {
  align-items: center;
  .fixedBottom {
    position: fixed;
    bottom: 0;
    right: 15px;
    background: #fff;
  }
}
</style>
